(function() {
  // Listen for messages from parent window and triggers actions inside iframe
  window.iFrameResizer = {
    onReady: () => {
      const $mainContainer = $(this.document.body).find('.main-content, .site-content, #main-content');
      const $contentWrapper = $mainContainer?.length ? $($mainContainer.get(0)) : $(this.document.body);

      // Added to calculate document height in vulcan iframes more efficiently (VUL-11258)
      $contentWrapper.attr('data-iframe-height', 'iFrameResizer');
    },
    onMessage : (data) => {
      if (data && '_SUBMIT' in data && data['_SUBMIT'] === 'cart') {
        const $addBtn = $(`a[data-sku-base-id="${data.SKU_BASE_ID[0]}"].js-add-to-cart.hidden`);
        $(document).trigger('addToCart.toggle', [$addBtn]);
      }
    }
  };
})();